import { render, staticRenderFns } from "./CommunityElderByAge.vue?vue&type=template&id=4d1ce3c5&scoped=true&"
import script from "./CommunityElderByAge.vue?vue&type=script&lang=js&"
export * from "./CommunityElderByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ce3c5",
  null
  
)

export default component.exports